const APP_TABLE = {
    APPS: "APPS",
    ASSESSMENTS: "ASSESSMENTS"
};

export {
    APP_TABLE
};
